import client from 'src/utils/api/client';
import { GET_OBJECT_PRE_SIGNED_URL } from 'src/graphql/attachment/query';

export default async (id, realName, thumbnailType, options= {}) => {
  const result = await client.query({
    ...options,
    query: GET_OBJECT_PRE_SIGNED_URL,
    variables: realName ? {
      id,
      realName,
      thumbnailType
    } : { id, thumbnailType },
  });
  const { url } = (result || { data: {} }).data.getObjectPreSignedUrl;
  return url;
};
